import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import DigitalTransformation from './DigitalTransformation';

export default function Blog() {
  return (
    <>
        <Navbar />
        <DigitalTransformation />
        <Footer />
        <Copyright />
    </>
  )
}